module.exports = __webpack_public_path__ + "img/logo.9a421c2c.png";